(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sale-price-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sale-price-slider')) {
  customElements.define('sale-price-slider', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); }
    setup() {
      if (this.ready || !this.querySelector('[data-min-slider]')) return;
      this.ready = true;
      this.low = this.querySelector('[data-min-slider]');
      this.high = this.querySelector('[data-max-slider]');
      this.lowField = this.querySelector('[data-min-field]');
      this.highField = this.querySelector('[data-max-field]');
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'es-CO', {
        style:'currency', currency:this.dataset.currency || 'COP', maximumFractionDigits:0
      });
      [this.low, this.high].forEach(input => {
        input.addEventListener('input', event => {
          event.stopPropagation();
          this.update(input);
        });
        input.addEventListener('change', () => {
          this.update(input);
          this.lowField.dispatchEvent(new Event('input', {bubbles:true}));
        });
      });
      this.paint();
    }
    update(input) {
      let low = Number(this.low.value), high = Number(this.high.value);
      if (low > high) {
        if (input === this.low) this.low.value = high;
        else this.high.value = low;
      }
      this.lowField.value = Number(this.low.value) > 0 ? this.low.value : '';
      this.highField.value = Number(this.high.value) < Number(this.high.max) ? this.high.value : '';
      this.paint();
    }
    paint() {
      const low = Number(this.low.value), high = Number(this.high.value);
      const limit = Number(this.high.max) || 1;
      this.style.setProperty('--range-start', (low / limit * 100) + '%');
      this.style.setProperty('--range-end', (high / limit * 100) + '%');
      this.querySelector('[data-min-output]').textContent = this.formatter.format(low);
      this.querySelector('[data-max-output]').textContent = this.formatter.format(high);
      this.low.setAttribute('aria-valuetext', this.formatter.format(low));
      this.high.setAttribute('aria-valuetext', this.formatter.format(high));
      this.low.style.zIndex = low >= limit ? '3' : '1';
      this.high.style.zIndex = '2';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
